/**
 * Detects CPF/CNPJ validation messages returned by the API (nested JSON).
 */
export function responseContainsCpfCnpjValidationError (data) {
  if (data == null) {
    return false
  }
  if (typeof data === 'string') {
    const s = data.toLowerCase()
    return (
      s.includes('valid cpf') ||
      s.includes('valid cnpj') ||
      s.includes('cpf inválido') ||
      s.includes('cnpj inválido')
    )
  }
  if (Array.isArray(data)) {
    return data.some(item => responseContainsCpfCnpjValidationError(item))
  }
  if (typeof data === 'object') {
    return Object.keys(data).some(k => responseContainsCpfCnpjValidationError(data[k]))
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/quizValidationErrors.js